import cuid from "cuid";
import { defaults, get, keyBy, map } from "lodash";
import { useQuery } from "shared/hooks/useApi";
import { SUBSCRIPTION } from "utils/api/graphql/queries/subscription";
import { CONTACT_POINT_SYSTEM, KEYS } from "utils/constants";
import { buildDepartmentSkills } from "utils/helpers/address";
import Navbar from "../Components/Navbar/Navbar";
import { resolveDefaultAddressCountry } from "../utils/zipCode";
import View from "./View";

const AdherentTelecoms = ({
  project,
  onNext,
  onBack,
  currentStatus,
  tracer,
  updateUrl,
}) => {
  const existingTelecoms = keyBy(get(project, "contact.telecoms"), "system");
  const zipCode = get(
    existingTelecoms,
    `${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
  );
  const telecoms = defaults(existingTelecoms, {
    [CONTACT_POINT_SYSTEM.ADDRESS]: { value: null },
    [CONTACT_POINT_SYSTEM.CITY]: { value: null },
    [CONTACT_POINT_SYSTEM.ZIP_CODE]: { value: null },
    [CONTACT_POINT_SYSTEM.COUNTRY]: {
      value: resolveDefaultAddressCountry(zipCode),
    },
  });
  const subscriptionId =
    get(project, "fields.currentSubscription") ||
    localStorage.getItem(KEYS.SUBSCRIPTION_ID);
  const { data } = useQuery(SUBSCRIPTION, {
    variables: { where: { id: subscriptionId } },
  });
  const onSubmit = ({ telecoms }) => {
    const updatedTelecoms = map(telecoms, (item, key) =>
      defaults(item, { id: cuid(), system: key }),
    );
    const source = localStorage.getItem(KEYS.SOURCE);
    updateUrl({
      subscriptionId,
      url: get(
        data,
        "subscription.insurancePlan.config.generatedUrl",
        `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`,
      ),
    });
    const nextZipCode = get(telecoms, `${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`);
    return onNext({
      payload: {
        contact: {
          id: get(project, "contact.id") || cuid(),
          telecoms: updatedTelecoms,
        },
        fields: {
          ...get(project, "fields", {}),
          skills: buildDepartmentSkills(
            get(project, "fields.skills", {}),
            nextZipCode,
          ),
        },
      },
    });
  };
  return (
    <>
      <Navbar
        project={project}
        currentStatus={currentStatus}
        tracer={tracer}
        showCart
        showProfile
      />
      <View
        telecoms={telecoms}
        onNext={onSubmit}
        onBack={onBack}
        locked={project?.locked}
      />
    </>
  );
};

export default AdherentTelecoms;
